import {ChangeDetectionStrategy, Component, ViewEncapsulation} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";


@Component({
    selector: "section-requests-list-all",
    template: `
        <h1 class="container-heading">Requests</h1>
        <mat-card>
            <mat-card-content>
                <section-requests-list [state]="state"></section-requests-list>
            </mat-card-content>
        </mat-card>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class RequestsListAllComponent implements Base.IComponent {


    public readonly state: Base.IState;

    public constructor() {
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "support-requests-all",
            actions: {
                "browse": ["browse_requests"]
            }
        };
    }
}
